
<template>
  <div style="font-family: 'Roboto Slab', serif">
    <div v-if="Request == null || Request == '' || Request == undefined">
      <center class="loading-medium">
        <loading></loading>
      </center>
    </div>
    <div
      v-if="Request"
      style="
        width: 800px;
        height: 1250px;
        border: 1px solid black;
        margin: auto;
        padding: 20px;
        font-size: 14px;
      "
    >
      <div style>
        <div class="col-xs-3">
          <!-- <img
            src="../../assets/imgs/png/FAJRLOGO01.png"
            style="float: left; height: 90px; width: 130px"
          /> -->
        </div>
        <div class="col-xs-6">
          <h3
            style="
              font-weight: 500;
              margin-top: 60px;
              font-size: 28px;
              font-family: 'Roboto Slab', serif;
            "
          >
            SALE CONFIRMATION
          </h3>
        </div>
        <div class="col-xs-3">
          <img
            :src="BankLogo"
            style="float: right; height: 44px; width: 195px"
          />
        </div>
      </div>
      <br clear="all" />
      <!-- <h2
      style="text-align:center;padding-bottom:0;border-top:solid 1px #000;margin-bottom:2px;padding-bottom:5px;padding-top:5px;border-bottom:solid 1px #000;"
      >SELLER'S OFFER</h2>-->

      <!-- <div style="padding-top:0;margin-top:0;height:1px;border-top:solid 1px #000;margin-top:1px"></div> -->
      <hr style="border: 1.2px solid #b35900" />
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-2" style="font-weight: bold">From:</div>
          <div class="col-xs-6">
            {{ Request.BankName }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-2" style="font-weight: bold">To:</div>
          <div class="col-xs-6">
            {{ Request.PurchaserName }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-2" style="font-weight: bold">Date:</div>
          <div class="col-xs-6">
            {{ DateFromat(Request.ApplicationDate, true) }}
          </div>
        </div>
      </div>

      <hr style="border: 1px solid #b35900; margin-top: 5px" />

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-12" style="text-align: justify">
            This form is subject to the terms and conditions of the
            <b>Spot Sale Agreement</b> signed between us dated
            <b>{{ AggrementDate }}</b
            >.
            <br />
            <br />

            We refer to our telephone conversation/ electronic platform dated
            <b> {{ DateFromat(Request.ApplicationDate, true) }}</b> and for the
            receipt of the document of title for the said commodity

            {{
              Request.TransferOfOwner == true
                ? "legaly owned by " + Request.TransferOwner
                : ""
            }}.

            <br />
            <br />
            We confirm that the terms of the Sale Transaction, which we agreed
            over the telephone / platform with you, are as follows:
          </div>
        </div>
      </div>
      <br />

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: bold">
            Seller's Reference::
          </div>
          <div class="col-xs-7">
            {{ Request.BankReference }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: bold">
            Purchaser's Reference:
          </div>
          <div class="col-xs-7">
            {{ Request.RefNo }}
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: -15px">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Commodity:</div>
          <div class="col-xs-7">{{ Request.CommodityName }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Quantity:</div>
          <div class="col-xs-7">
            {{ Request.StringQuantity }} {{ Request.UnitName }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">
            Commodity Description:
          </div>
          <div class="col-xs-7">99.95% pt - 'Good Delivery'</div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">
            Commodity Supplier:
          </div>
          <div class="col-xs-7">Fajr Investment Advisory</div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Total Sale Price:</div>
          <div class="col-xs-7">
            {{ Request.CurrencyShortname }} {{ Request.StringAmount }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Unit Price:</div>
          <div class="col-xs-7">
            {{ Request.CurrencyShortname }} {{ Request.StringUnitPrice }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Payment Date:</div>
          <div class="col-xs-7">
            {{ DateFromat(Request.ValueDate, true) }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Delivery Date:</div>
          <div class="col-xs-7">{{ DateFromat(Request.ValueDate, true) }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">
            Location Of Delivery::
          </div>
          <div class="col-xs-7">{{ Request.SupplierLocation }}</div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-12" style="text-align: justify">
            <p>
              Your payment of the Total Sale Price is to be made on the Payment
              Date to our account with Fajr Investment Advisory.
            </p>
            <p style="margin-top: 15px">
              This Sale Transaction shall be upon and subject to the terms of
              the Agreement and words and expressions defined in the Agreement
              shall have the same meaning when used herein.
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-12">
            <br />For and on behalf of
            <br />
            <b>{{ Request.BankName }}</b> Riyadh, Kingdom of Saudi Arabia
            <br />
          </div>
        </div>
      </div>
      <br />
      <br />
      <p style="text-align: center; font-size: 10px; margin-bottom: -15px">
        <em style="font-size: 16px"
          >This is a computer generated document, issued by a secure platform
          and as such, does not require a signature.</em
        >
      </p>
      <hr style="border: 1px solid #b35900" />
      <p style="font-size: 14px; text-align: center; margin-top: -30px">
        <br />Riyadh, Kingdom of Saudi Arabia, www.alinmacapital.com
      </p>
    </div>
  </div>
</template>

<style scoped>
* {
  font-size: 18px;
}
</style>

  <script>
import { mapGetters, mapState } from "vuex";
export default {
  computed: {
    ...mapGetters({
      Request: "GETBUYREQUEST",
      AggrementDate: "GETASTONAGGREMENTDATE",
      BankLogo: "GETBANKLOGO",
    }),
  },
};
</script>
<style scopped>
tr td {
  border: 0;
}
.Details > tr > td:nth-child(odd) {
  width: 26%;
}
</style>
